<template>
  <div class="card mb-4 shadow-sm border border-light">
    <div class="card-body pt-3 px-3 pb-2">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <titles text="Xəbərdarlıqlar" style="margin: 0;" />
        <span class="top-info">Top 50</span>
      </div>
      <hr class="my-2" />
      <div style="max-height: 325px; overflow-y: auto; padding-right: 6px;">
        <div v-for="(item, idx) in topWarnings" :key="idx"
          class="custom-warning-box border border-light mb-2 px-3 py-2">
          <div class="d-flex justify-content-between align-items-start">
            <div class="text-part">
              <div class="subrogation">
                <a href="javascript:void(0)" class="id" @click="openSubrogation(item.subrogationId)"
                  style="text-decoration: underline; color: #409eff;">
                  Subroqasiya işi №{{ item.subrogationNumber }}
                </a>
                <span class="status-name">— {{ item.statusName }}</span>
              </div>
              <div class="desc">{{ item.description || '-' }}</div>
            </div>
            <div class="date-part text-end">
              <div class="date text-muted mb-1">
                <i class="fa fa-calendar-alt me-1"></i>{{ formatDate(item.statusDate) }}
              </div>
              <el-tag :type="tagType(item.overdueDays)" size="small">
                {{ item.overdueDays }} gün
              </el-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Titles from "@/project/Components/Titles.vue";
import { GetWarningJournal } from "@/project/Source/journals.js";

export default {
  components: { Titles },
  data() {
    return {
      warnings: [],
    };
  },
  computed: {
    topWarnings() {
      return this.warnings.slice(0, 50);
    }
  },
  mounted() {
    this.fetchWarnings();
  },
  methods: {
    async fetchWarnings() {
      try {
        const res = await GetWarningJournal({
          page: 1,
          pageSize: 50,
          searchText: ""
        });
        this.warnings = res.data.data || [];
      } catch (e) {
        console.error("Xəbərdarlıqlar yüklənmədi:", e);
      }
    },
    openSubrogation(id) {
      const route = this.$router.resolve({
        name: "Subroqasiya - Məlumat",
        params: { id }
      });
      window.open(route.href, "_blank");
    },
    formatDate(d) {
      if (!d) return "";
      const x = new Date(d);
      return `${x.getDate().toString().padStart(2, "0")}.${(x.getMonth() + 1)
        .toString()
        .padStart(2, "0")}.${x.getFullYear()}`;
    },
    tagType(o) {
      if (o >= 25) return "danger";
      if (o >= 20) return "warning";
      if (o >= 0) return "success";
      return "";
    }
  }
};
</script>


<style scoped>
.btn-sm {
  padding: 3px 8px;
}

.custom-warning-box {
  border-left: 2px solid #409EFF;
  background-color: #fff;
  border-radius: 6px;
  transition: box-shadow 0.15s ease;
  font-size: 11px;
  line-height: 1.4;
  padding: 6px 10px !important;
}

.custom-warning-box:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.subrogation {
  font-size: 12px;
  font-weight: 600;
  color: #7e22ce;
  margin-bottom: 1px;
}

.subrogation .id {
  color: #004eb3 !important;
  font-weight: 600;
}

.subrogation .status-name {
  color: #1f2937;
  font-weight: 500;
  margin-left: 4px;
}


.desc {
  font-size: 11px;
  color: #374151;
}

.date {
  font-size: 10px;
  color: #6b7280;
}

.text-part {
  max-width: calc(100% - 120px);
}

.date-part {
  min-width: 100px;
}

.daha-cox-btn {
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 6px;
}

/* Стилизация вертикального скролла */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
}
.row-success td { background:#fffbe6; color:#b45309; }

.row-warning td { background:#fff2cc; color:#b45309; }

.row-danger  td { background:#fdecea; color:#b91c1c; }

.el-tag--success {
  background-color:#ffecb3 !important;
  border-color:#ffecb3 !important;
  color:#b45309 !important;
}
</style>
